const COLUMNS = [
  { key: 'company', label: 'Company Name' },
  { key: 'role', label: 'Role Title' },
  { key: 'status', label: 'Status' },
  { key: 'dateApplied', label: 'Date Applied' },
  { key: 'jobUrl', label: 'Job URL' },
  { key: 'location', label: 'Location' },
  { key: 'salary.min', label: 'Salary Min' },
  { key: 'salary.max', label: 'Salary Max' },
  { key: 'salary.currency', label: 'Salary Currency' },
  { key: 'salary.period', label: 'Salary Period' },
  { key: 'source', label: 'Source' },
  { key: 'priority', label: 'Priority' },
  { key: 'nextAction', label: 'Next Action' },
  { key: 'nextActionDate', label: 'Next Action Date' },
  { key: 'tags', label: 'Tags' },
];

export function exportToCsv(applications) {
  const header = COLUMNS.map((c) => c.label).join(',');

  const rows = applications.map((app) =>
    COLUMNS.map((col) => {
      let val;
      if (col.key.startsWith('salary.')) {
        val = app.salary?.[col.key.split('.')[1]] ?? '';
      } else if (col.key === 'tags') {
        val = (app.tags || []).join('; ');
      } else {
        val = app[col.key] ?? '';
      }
      const str = String(val);
      return str.includes(',') || str.includes('"') || str.includes('\n')
        ? `"${str.replace(/"/g, '""')}"`
        : str;
    }).join(',')
  );

  const csv = [header, ...rows].join('\n');
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);

  const a = document.createElement('a');
  a.href = url;
  a.download = `launchpad-export-${new Date().toISOString().slice(0, 10)}.csv`;
  a.click();
  URL.revokeObjectURL(url);
}
